import { defineCopy } from '@floorfile/i18n'
import { commentsCopy } from './copy'

export const commentsOfflineCopy = defineCopy('comments', { offlineAction: commentsCopy.en.offlineAction })
